import type { FC } from "react";

import { SWReactCountryIcons } from "@similarweb/icons";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import type { ICountryObject } from "app/services/CountryService";

type Props = {
    country?: ICountryObject;
    title: string;
};
const SignalTitleWithCountryIcon: FC<Props> = ({ country, title }) => {
    if (!country) {
        return title;
    }

    return (
        <Flex
            gap="4px"
            alignItems="baseline"
        >
            <Box>
                <SWReactCountryIcons
                    countryCode={country.id}
                    size="xs"
                />
            </Box>
            <div
                dangerouslySetInnerHTML={{
                    __html: title,
                }}
            />
        </Flex>
    );
};

export default SignalTitleWithCountryIcon;
